import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/observable/of';
import { Client } from '../../shared/services/client';

@Injectable()
export class PassangerService {

  constructor ( private http: HttpClient, private client: Client ) {
  }

  getPassanger ( phone, service ) {
    return this.http.post( this.client.getPassengerUrl(), {
      'passenger': { 'phone_number': phone, 'country': 'ua' }, 'service': service
    } );
  }
  getPassengerById (id, service?) {
    return this.http.get( this.client.getPassengerUrl(), {'params': {'id': id, 'service': service }});
  }

  setPassanger ( obj, service ) {
    return this.http.post( this.client.getPassengerUrl(), { 'passenger': obj, 'service': service } );
  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/services/passanger.service.ts